import type { PrivacyPageLocaleContent } from '../types'

export const privacyPageEs: PrivacyPageLocaleContent = {
  dateLocale: 'es-ES',
  title: 'Política de Privacidad - Toolvance',
  description: 'Política de privacidad de Toolvance.',
  metadata: {
    ogTitle: 'Política de Privacidad - Toolvance',
    ogDescription: 'Política de privacidad de Toolvance.',
    robots: 'noindex',
  },
  content: {
    heading: 'Política de Privacidad',
    updatedLabel: 'Última actualización',
    sections: [
      {
        heading: 'Qué recopilamos',
        body: 'Toolvance es un sitio web estático. No recopilamos, almacenamos ni procesamos información personal identificable. Todos los cálculos se realizan completamente en tu navegador y no se envían datos de cálculo a ningún servidor.',
      },
      {
        heading: 'Analítica',
        body: 'Podemos usar analítica anonimizada para entender qué calculadoras son más populares. No se recopilan ni almacenan datos personales identificables.',
      },
      {
        heading: 'Cookies',
        body: 'Este sitio web no utiliza cookies con fines de seguimiento o publicidad.',
      },
      {
        heading: 'Servicios de terceros',
        body: 'No compartimos datos con terceros porque no recopilamos datos para compartir.',
      },
    ],
    contactHeading: 'Contacto',
    contactPrefix: 'Si tienes preguntas sobre esta política de privacidad, por favor ',
    contactLinkText: 'contáctanos',
    contactSuffix: '.',
  },
}
